import { useMutation } from "@tanstack/react-query";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { requestURLs } from "@/Environment";

export type ReferenceMutateResponse = ResponseType<any>;

export function useCreateReferenceMutation(type: "workstream" | "project-type" | "project-phase" | "project-priority" | "project-category" | "cost-type" | "tag") {
  return useMutation<
    AxiosResponseAndError<ReferenceMutateResponse>["response"],
    AxiosResponseAndError<ReferenceMutateResponse>["error"],
    Record<string, any>
  >({
    mutationFn: (data) =>
      ApiRequest.post<ReferenceMutateResponse>(
        `${requestURLs.reference}/${type}`,
        data
      ),
  });
}

export function useUpdateReferenceMutation(type: "workstream" | "project-type" | "project-phase" | "project-priority" | "project-category" | "cost-type" | "tag") {
  return useMutation<
    AxiosResponseAndError<ReferenceMutateResponse>["response"],
    AxiosResponseAndError<ReferenceMutateResponse>["error"],
    { id: string; data: Record<string, any> }
  >({
    mutationFn: ({ id, data }) =>
      ApiRequest.put<ReferenceMutateResponse>(
        `${requestURLs.reference}/${type}/${id}`,
        data
      ),
  });
}

export function useRemoveReferenceMutation(type: "workstream" | "project-type" | "project-phase" | "project-priority" | "project-category" | "cost-type" | "tag") {
  return useMutation<
    AxiosResponseAndError<ResponseType<null>>["response"],
    AxiosResponseAndError<ResponseType<null>>["error"],
    string
  >({
    mutationFn: (id) =>
      ApiRequest.delete<ResponseType<null>>(
        `${requestURLs.reference}/${type}/${id}`
      ),
  });
}
